import { Avatar, Button, Space, Typography } from 'antd'
import { VenueMenus as VenueMenusModel } from '../../models/VenueMenus'
import { LinkOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

const { Text } = Typography

interface Props {
  model?: VenueMenusModel
  style?: React.CSSProperties
}

export const VenueMenu = ({ model, style }: Props) => {
  const menu = model

  if (!menu) {
    return <></>
  }

  return (
    <Space style={style} className="w-full space-between">
      <Text>
        {menu.enLabel} | {menu.frLabel}
      </Text>
      <Link to={menu.url} target="blank">
        <Button icon={<LinkOutlined />} />
      </Link>
    </Space>
  )
}

export type VenueMenuType = { Menu: typeof VenueMenu }
